import { Check } from "lucide-react";
import {
  PageHero,
  Reveal,
  FinalCTA,
  usePageMeta,
} from "../components/Common";
import { EXPERIENCE_BLOCKS } from "../data/content";

const BLOCK_IMAGES = [
  { src: "/assets/david-presenting.png", alt: "David Duenzl facilitating a staff professional development session" },
  { src: "/assets/school-lindenhall.jpg", alt: "Linden Hall High School campus, Fukuoka Prefecture, Japan" },
  { motto: "From Language to Leadership." },
  { motto: "Bridging Cultures in International Education." },
  { src: "/assets/david-executive-bw.png", alt: "David Duenzl, executive portrait" },
];

const Experience = () => {
  usePageMeta(
    "Experience — English for Leaders",
    "Leadership experience across International School Westpfalz (Germany), Linden Hall (Japan), international English communication and independent EdTech advisory.",
    "/experience"
  );

  return (
    <div data-testid="experience-page">
      <PageHero
        testid="experience-hero"
        eyebrow="Experience"
        title="Real schools. Real challenges. Practical solutions."
        intro="An advisory perspective grounded in practice — school leadership, international recruitment, corporate communication, university collaborations and educational technology, across Australia, Japan and Germany."
      />

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          {EXPERIENCE_BLOCKS.map((block, i) => {
            const image = BLOCK_IMAGES[i];
            const textCell = (
              <div className="flex flex-col justify-center py-12 lg:py-16" key="text">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-crimson">
                  {block.role}
                </p>
                <h2 className="mt-4 font-display text-2xl leading-snug tracking-tight text-navy sm:text-3xl">
                  {block.title}
                </h2>
                <ul className="mt-6 space-y-3">
                  {block.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-base leading-relaxed text-charcoal/80">
                      <Check className="mt-1 h-4 w-4 shrink-0 text-crimson" strokeWidth={2.5} />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            );

            const imageCell = image?.src ? (
              <div className="relative min-h-[260px] lg:min-h-[380px]" key="image">
                <img
                  src={image.src}
                  alt={image.alt}
                  className="absolute inset-0 h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
            ) : (
              <div
                className="relative flex min-h-[260px] items-center justify-center bg-navy lg:min-h-[380px]"
                key="motto"
              >
                <p className="max-w-xs px-8 text-center font-display text-2xl leading-snug text-white">
                  {image.motto}
                </p>
              </div>
            );

            return (
              <Reveal
                key={block.title}
                className={`grid gap-10 lg:grid-cols-2 lg:gap-16 ${
                  i > 0 ? "border-t border-navy/10" : ""
                }`}
              >
                {i % 2 === 0 ? (
                  <>
                    {textCell}
                    {imageCell}
                  </>
                ) : (
                  <>
                    {imageCell}
                    {textCell}
                  </>
                )}
              </Reveal>
            );
          })}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
};

export default Experience;
